import { cls } from "@wss/cls";
import React, { ComponentProps, useEffect, useReducer } from "react";
import Category from "./components/Category";
import { reducer, initialState, withActions } from "./module";
import { SuperSimpleCarousel } from "@wss/carousel";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { User, withUserAndChat } from "~/common/Store/connectUserAndChat";
import SkeletonContainer from "./components/SkeletonContainer";
interface PersonalizedCategoryContainerProps extends ComponentProps<"div"> {
  user: User;
}
const PersonalizedCategoryContainer = withUserAndChat(({
  className,
  user
}: PersonalizedCategoryContainerProps) => {
  const [state, actions] = withActions(useReducer(reducer, initialState));
  const [step, setStep] = React.useState<number | undefined>(undefined);
  useEffect(() => {
    if (!user || !state.loading) {
      return;
    }
    actions.fetchRecommendations(user);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  useEffect(() => {
    const updateStep = () => {
      setStep(window.innerWidth < 500 ? 1 : undefined);
    };
    updateStep();
    const resizeObserver = new ResizeObserver(() => {
      updateStep();
    });
    resizeObserver.observe(document.body);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const items = state.categories.map(category => [<Category className="xl:mr-4 xl:last:mr-0" categoryName={category.categoryName} loading={state.loading} items={category.items} />, category.categoryName]);
  if (state.fetchError) {
    return null;
  }
  if (state.loading) {
    return <SkeletonContainer className={className} />;
  }
  return <>
        <SuperSimpleCarousel className="container xl:hidden pb-6 xl:pb-10" step={step}>
          <SuperSimpleCarousel.Previous className={cls("bg-white flex items-center justify-center hover:bg-stone-50 border border-solid border-gray-300 rounded-[5px] shadow-sm h-10 w-10 p-0 absolute left-2-1/2 top-1/2 -translate-y-1/2", "focus-visible:border-2", "lg:left-3")} key={state.categories.map(category => category.categoryName).join(",")}>
            <Icon name="ri-arrow-left-s-line" className="fill-green-500 w-6 h-6" />
          </SuperSimpleCarousel.Previous>
          <SuperSimpleCarousel.Content className="m-0">
            {items.map(([item, name]) => <SuperSimpleCarousel.Item key={name as string} className="mr-4 last:mr-0">
                {item}
              </SuperSimpleCarousel.Item>)}
          </SuperSimpleCarousel.Content>
          <SuperSimpleCarousel.Next className={cls("bg-white flex items-center justify-center hover:bg-stone-50 border border-solid border-gray-300 rounded-[5px] shadow-sm h-10 w-10 p-0 absolute right-2-1/2 top-1/2 -translate-y-1/2", "focus-visible:border-2", "lg:right-3")} key={state.categories.map(category => category.categoryName).join(",")}>
            <Icon name="ri-arrow-right-s-line" className="fill-green-500 w-6 h-6" />
          </SuperSimpleCarousel.Next>
        </SuperSimpleCarousel>
        <div className={cls("hidden",
    // hide when screen is smaller than 1024px - show carousel version instead
    "xl:flex", className)}>
          {items.map(([item]) => item)}
        </div>
      </>;
});
export default PersonalizedCategoryContainer;